import styled from "styled-components";

export const ProductImg = styled.img`
  border-radius: 10px;
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;